<template>
  <div class="loader">
    <div class="container">
      <div class="loader__inner">
        <div class="process">
          <status-icon
            :name="'process'"
          />
        </div>
      </div>
    </div>
  </div>
</template>
<script lang="ts">
import { defineComponent } from 'vue';
import statusIcon from '@/components/icons/statusIcon.vue';

export default defineComponent({
  components: {
    statusIcon
  }
});
</script>
<style lang="scss" scoped>
.loader{
  height: 620px;
  padding: 40px 0;
  &__inner{
    text-align: center;
    height: 100%;
    margin: auto 16px;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: $primary-white;
  }
}
.process{
    -webkit-animation:spin 1.5s linear infinite;
    -moz-animation:spin 1.5s linear infinite;
    animation:spin 1.5s linear infinite;
    width: 50px;
    height: 50px;
}
.process__icon{
    display: block;
}
@-moz-keyframes spin {
    100% { -moz-transform: rotate(360deg); }
}
  
@-webkit-keyframes spin {
  100% { -webkit-transform: rotate(360deg); }
}

@keyframes spin {
  100% {
    -webkit-transform: rotate(360deg);
    transform:rotate(360deg);
  }
}
</style>